// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"66":"2505f079","488":"be739fa7"}[chunkId] + ".chunk.js");